










































































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Prop, Vue } from "vue-property-decorator";
import { pageDataType } from "../types";
import { HOST } from "../global";

@Component({
  name: "InvestorTab",
})
export default class InvestorTab extends Vue {
  @Prop() readonly compData!: any;
  public HOST: string = HOST;
  current = 0;
  current_image_number = 0;

  // current_img = 0;

  itemClick(index: any) {
    if ((this as any).current == index) {
      (this as any).current = 0;
    } else {
      (this as any).current = index;
    }
  }
}
